'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _messages = require('common/messages');

var _adverseEvents = require('./adverse-events.html');

var _adverseEvents2 = _interopRequireDefault(_adverseEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _adverseEvents2.default,
  bindings: {
    flex: '@',
    layout: '@',
    adverseEvents: '<',
    alerts: '<',
    animalTypes: '<',
    eventTypes: '<',
    searchCriteria: '<',
    searchTypes: '<',
    sexes: '<',
    statuses: '<',
    symptoms: '<',
    injuryProbabilities: '<',
    injurySeverities: '<',
    occurrenceLikelihoods: '<',
    query: '<',
    limitOptions: '<'
  },
  controller: function () {
    function AdverseEventsComponent($mdDialog, $scope, $state, AdverseEventService, AdverseEventsService, CompanyService, AuthService, ToastService) {
      'ngInject';

      var _this = this;

      _classCallCheck(this, AdverseEventsComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $scope: $scope,
        $state: $state,
        AdverseEventService: AdverseEventService,
        AdverseEventsService: AdverseEventsService,
        AuthService: AuthService,
        CompanyService: CompanyService,
        ToastService: ToastService
      });

      this.onPaginationChanged = function (page, take) {
        _this.query = _extends({}, _this.query, {
          page: page,
          take: take
        });

        _this.refreshResults();
      };

      this.onOrderChanged = function (order) {
        var direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
        var orderBy = order.replace('-', '');

        _this.query = _extends({}, _this.query, {
          direction: direction,
          orderBy: orderBy
        });

        _this.refreshResults();
      };
    }

    _createClass(AdverseEventsComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.searchCriteria = this.searchCriteria || {};
        this.selectedAdverseEvents = [];
      }
    }, {
      key: 'refreshResults',
      value: function refreshResults() {
        var _this2 = this;

        this.AdverseEventsService.setQuery(this.query);

        if (!this.searchCriteria.selectedSearchType) {
          return;
        }

        switch (this.searchCriteria.selectedSearchType) {
          case 'Open Adverse Events':
            this.promise = this.AdverseEventsService.getAdverseEventsByStatus('OPEN');
            break;
          case 'Search by Report Date':
            if (this.searchCriteria.selectedReportDate) {
              this.promise = this.AdverseEventsService.getAdverseEventsByReportDate(this.searchCriteria.selectedReportDate);
            }
            break;
          case 'Search by Product Name':
            if (this.searchCriteria.selectedProduct) {
              this.promise = this.AdverseEventsService.getAdverseEventsByProduct(this.searchCriteria.selectedProduct.ProductId);
            }
            break;
          case 'Search by Ingredient Name':
            if (this.searchCriteria.selectedIngredient) {
              this.promise = this.AdverseEventsService.getAdverseEventsByIngredient(this.searchCriteria.selectedIngredient.UserIngredientId);
            }
            break;
          case 'Search by System Ingredient':
            if (this.searchCriteria.selectedIngredient) {
              this.promise = this.AdverseEventsService.getAdverseEventsBySystemIngredient(this.searchCriteria.selectedIngredient.SystemIngredientId);
            }
            break;
          case 'Search by Member':
            if (this.searchCriteria.selectedCompany) {
              this.promise = this.AdverseEventsService.getAdverseEventsByMember(this.searchCriteria.selectedCompany.MemberId);
            }
            break;
          case 'Search by Event (any events)':
            if (this.searchCriteria.selectedEventTypes) {
              this.promise = this.AdverseEventsService.getAdverseEventsByType(this.searchCriteria.selectedEventTypes, false);
            }
            break;
          case 'Search by Event (all matched events)':
            if (this.searchCriteria.selectedEventTypes) {
              this.promise = this.AdverseEventsService.getAdverseEventsByType(this.searchCriteria.selectedEventTypes, true);
            }
            break;
          case 'Search by Species':
            if (this.searchCriteria.selectedSpecies) {
              this.promise = this.AdverseEventsService.getAdverseEventsBySpecies(this.searchCriteria.selectedSpecies);
            }
            break;
          case 'Search by Text':
            if (this.searchCriteria.searchByText) {
              this.promise = this.AdverseEventsService.getAdverseEventsByText(this.searchCriteria.searchByText);
            }
            break;
          case 'Missing Event Information':
            this.promise = this.AdverseEventsService.getAdverseEventsMissingInfo();
            break;
          default:
            this.promise = this.AdverseEventsService.getAdverseEvents();
        }

        if (!this.promise) {
          this.promise = this.AdverseEventsService.getAdverseEvents();
        }

        this.promise.then(function (r) {
          _this2.adverseEvents = {
            Count: r.data.Count,
            Data: r.data.Data
          };

          _this2.promise = undefined;
        }).catch(function (error) {
          return _this2.ToastService.showError(error);
        });
      }
    }, {
      key: 'onSearchChanged',
      value: function onSearchChanged(_ref) {
        var searchCriteria = _ref.searchCriteria;

        this.searchCriteria = searchCriteria;
        this.query = _extends({}, this.query, {
          searchText: this.searchCriteria.searchText,
          seriousAEsOnly: this.searchCriteria.seriousAEsOnly
        });

        this.refreshResults();
      }
    }, {
      key: 'searchTextChanged',
      value: function searchTextChanged($event) {
        this.query = _extends({}, this.query, {
          searchText: $event.searchText
        });

        this.refreshResults();
      }
    }, {
      key: 'searchByTextChanged',
      value: function searchByTextChanged(_ref2) {
        var searchByText = _ref2.searchByText;

        this.searchCriteria.searchByText = searchByText;
        this.refreshResults();
      }
    }, {
      key: 'onEditClicked',
      value: function onEditClicked(adverseEventId) {
        this.$state.go('adverseEventEdit', { id: adverseEventId });
      }
    }, {
      key: 'onViewClicked',
      value: function onViewClicked(adverseEventId) {
        var _this3 = this;

        this.AdverseEventService.getAdverseEvent(adverseEventId).then(function (r) {
          var adverseEvent = r.data;

          _this3.AdverseEventService.getProductsByCompany(adverseEvent.MemberId).then(function (rp) {
            var products = rp.data;

            _this3.CompanyService.getCompany(adverseEvent.MemberId).then(function (rc) {
              var company = rc.data;

              if (!company.IsAllowMultiProductPerAE && adverseEvent.ProductIds && adverseEvent.ProductIds.length) {
                adverseEvent.ProductIds = adverseEvent.ProductIds[0];
              }

              var scope = _angular2.default.extend(_this3.$scope.$new(true), {
                adverseEvent: adverseEvent,
                symptoms: _this3.symptoms,
                animalTypes: _this3.animalTypes,
                sexes: _this3.sexes,
                injurySeverities: _this3.injurySeverities,
                injuryProbabilities: _this3.injuryProbabilities,
                occurrenceLikelihoods: _this3.occurrenceLikelihoods,
                statuses: _this3.statuses,
                products: products
              });

              _this3.$mdDialog.show({
                clickOutsideToClose: true,
                fullscreen: true,
                scope: scope,
                template: '\n            <md-dialog class="flex-75" style="max-height: 75%">\n              <md-dialog-content class="naers-dialog-content">\n                <dialog-close/>\n                <case-reference adverse-event="adverseEvent" \n                  locked="true" layout="column" flex>\n                </case-reference>\n                <contact-list adverse-event="adverseEvent"\n                  show-header="true" locked="true" layout="column" flex>\n                </contact-list>\n                <adverse-event-information adverse-event="adverseEvent" symptoms="symptoms"\n                  products="products"\n                  locked="true" layout="column" flex>\n                </adverse-event-information>\n                <animal-information adverse-event="adverseEvent" animal-types="animalTypes"\n                  sexes="sexes" locked="true" layout="column" flex>\n                </animal-information>\n\n                <animal-history adverse-event="adverseEvent" locked="true"\n                  layout="column" flex>\n                </animal-history>\n\n                <risk-analysis adverse-event="adverseEvent" injury-severities="injurySeverities"\n                  injury-probabilities="injuryProbabilities" occurrence-likelihoods="occurrenceLikelihoods"\n                  locked="true" layout="column" flex>\n                </risk-analysis>\n                <closure adverse-event="adverseEvent"\n                  statuses="::statuses"\n                  locked="true" layout="column" flex>\n                </closure>\n              </md-dialog-content>\n            </md-dialog>\n          '
              });
            });
          });
        }).catch(function (error) {
          return _this3.ToastService.showError(error);
        });
      }
    }, {
      key: 'alertClicked',
      value: function alertClicked(_ref3) {
        var alert = _ref3.alert;

        if (alert) {
          if (alert.AlertTypeID === 2) {
            this.searchCriteria = _extends({}, this.searchCriteria, {
              selectedSearchType: 'Open Adverse Events'
            });
            this.refreshResults();
          } else if (alert.AlertTypeID === 4) {
            if (this.AuthService.isSysAdmin) {
              this.$state.go('memberCompliance');
            } else {
              this.showAttestment();
            }
          }
        }
      }
    }, {
      key: 'showAttestment',
      value: function showAttestment() {
        var _this4 = this;

        this.AdverseEventsService.getOpenAdverseEventsPreviousMonth().then(function (r) {
          var adverseEvents = r.data;
          var scope = _angular2.default.extend(_this4.$scope.$new(true), {
            adverseEvents: adverseEvents,
            onAttested: function onAttested($event) {
              return _this4.onAttested($event);
            }
          });

          _this4.$mdDialog.show({
            clickOutsideToClose: true,
            fullscreen: true,
            scope: scope,
            template: '\n            <md-dialog class="flex-75" style="max-height: 75%">\n              <md-dialog-content>\n                <dialog-close/>\n                <attest\n                  adverse-events="adverseEvents"\n                  on-attested="onAttested($event)">\n                </attest>\n              </md-dialog-content>\n            </md-dialog>\n          '
          });
        }).catch(function (error) {
          return _this4.ToastService.showError(error);
        });
      }
    }, {
      key: 'onAttested',
      value: function onAttested(_ref4) {
        var _this5 = this;

        var signature = _ref4.signature;

        if (signature) {
          this.AdverseEventService.attest(signature).then(function () {
            _this5.ToastService.showSuccess(_messages.ADVERSE_EVENT_ATTESTED);
            _this5.$mdDialog.hide();
            _this5.$state.reload();
          }).catch(function (error) {
            return _this5.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'onDeleteClicked',
      value: function onDeleteClicked(adverseEvents) {
        var _this6 = this;

        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected adverse event(s) cannot be recovered!').ok('Delete').cancel('Cancel');

        this.$mdDialog.show(confirm).then(function () {
          var promises = [];
          for (var i = adverseEvents.length - 1; i >= 0; i -= 1) {
            promises.push(_this6.AdverseEventService.delete(adverseEvents[i].AEId));
          }

          Promise.all(promises).then(function () {
            _this6.ToastService.showSuccess(_messages.ADVERSE_EVENT_DELETED);
            _this6.refreshResults();
            _this6.selectedAdverseEvents = [];
          }).catch(function (error) {
            return _this6.ToastService.showError(error);
          });
        });
      }
    }]);

    return AdverseEventsComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/adverse-events/adverse-events.component.js